import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type Props = {
  isExpanded: boolean
  onClick?: () => void
  expandedColor?: string
}

const ExpandIcon = ({isExpanded, onClick, expandedColor}: Props) => {
  return <FontAwesomeIcon icon={faChevronRight} onClick={onClick} style={{
    transform: isExpanded ? 'rotate(90deg)' : 'inherit',
    transitionProperty: 'all',
    transitionDuration: '0.25s',
    color: isExpanded ? expandedColor : undefined
  }}
  />
}

export default ExpandIcon
